import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'contacts-value-textarea',
  templateUrl: './contacts-value-textarea.component.html',
  styleUrls: ['./contacts-value-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsValueTextareaComponent extends BaseResizableComponent {
  @Input() loading: boolean = false;
}
